import { Box } from '@chakra-ui/layout';
import { useConfig } from '@sgi/af-shell-shared';
import { ErrorAlert, Typography } from '@sgi/gravity';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { sgiClient } from 'src/services/sgiClient';
import { CustomerSearchByNumber } from './components/CustomerSearchByNumber';
import { CustomerSearchByName } from 'src/components/CustomerSearch/components/CustomerSearchByName';
import { CustomerSearchResults } from 'src/components/CustomerSearch/components/CustomerSearchResults';

interface CustomerSearchProps {
  title?: string;
  onSelectCustomer: (customerId: string) => void;
}

export const CustomerSearch = ({ title, onSelectCustomer }: CustomerSearchProps) => {
  const location = useLocation();
  const { REACT_APP_BFF_API_BASEURL } = useConfig();
  const [customerNumber, setCustomerNumber] = useState<string>(location.state?.searchTerm ?? '');

  const {
    data: customers,
    isLoading,
    error,
    isFetched,
  } = useQuery({
    queryKey: [REACT_APP_BFF_API_BASEURL, 'searchByCustomerNumber', customerNumber],
    queryFn: async () => sgiClient.driver.searchByCustomerNumber(REACT_APP_BFF_API_BASEURL, customerNumber!),
    enabled: !!customerNumber,
  });

  const [lastName, setLastName] = useState<string>(location.state?.searchTerm ?? '');
  const [firstName, setFirstName] = useState<string>(location.state?.searchTerm ?? '');
  const [searchByName, setSearchByName] = useState<boolean>(false);

  return (
    <Box>
      {/*<Typography variant="h2">Customer Search ({title})</Typography>*/}
      <Typography variant="h2">Driver Search {title ? `(${title})` : ''}</Typography>
      {!searchByName && (
        <Box>
          {/*(Enter Customer Number Below OR{' '}*/}
          {/*<a href="#" className="custom-button" onClick={changeSearchType}>*/}
          {/*  Search By Name here*/}
          {/*</a>*/}
          {/*)*/}
          <CustomerSearchByNumber isLoading={!!(customerNumber && isLoading)} initialCustomerNumber={customerNumber} onSubmit={setCustomerNumber} />
        </Box>
      )}
      {searchByName && (
        <CustomerSearchByName
          isLoading={false}
          initialLastName={lastName}
          initialFirstName={firstName}
          onSubmit={({ firstName, lastName }) => {
            setLastName(lastName);
            setFirstName(firstName);
          }}
        />
      )}

      {(error as Error) ? (
        <ErrorAlert>{(error as Error).toString()}</ErrorAlert>
      ) : isFetched ? (
        <CustomerSearchResults customers={customers ?? []} onSelectCustomer={onSelectCustomer} />
      ) : null}
    </Box>
  );
};
